import React, { useEffect, useState } from 'react';
import { CONTACT_TITLE, CONTACT_TYPE } from 'constant/contact';
import styles from './index.module.scss';
import { Spin } from 'antd';
import Icon from 'component/Icon';
import cooperationSDK from 'lib/cooperationSdk';
import recommendIcon from 'asset/image/addressbook_external_icon.svg';
// import labelIcon from 'asset/image/addressbook_label_icon_02.svg';
import wechatIcon from 'asset/image/addressbook_wechat_icon.svg';
import classnames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { getLabels, getContactList, getExternalContactList, getOrgContactList } from 'model/contact';
import { LabelList, Person } from 'type/contact';
import { RootState } from 'model';
import PersonList from 'component/PersonList';
import SearchContact from 'component/SearchContact';
import noContactImg from 'asset/image/kts_ addressbook.png';
import { getUserAuth } from 'data/storage';
// import ContactEditModal from '../ContactEditModal';
// import ConfirmModal from 'component/ConfirmModal';
import OrganizationList from 'component/OrganizationList';
import tracker from 'lib/tracker';

const groupData = [
  {
    key: CONTACT_TYPE.RECOMMEND,
    text: CONTACT_TITLE[CONTACT_TYPE.RECOMMEND],
    icon: recommendIcon
  },
  {
    key: CONTACT_TYPE.ORGANIZATION,
    text: CONTACT_TITLE[CONTACT_TYPE.ORGANIZATION],
    icon: wechatIcon
  }
  // {
  //   key: CONTACT_TYPE.LABEL,
  //   text: '标签',
  //   icon: labelIcon
  // },
  // {
  //   key: CONTACT_TYPE.EXTERNAL,
  //   text: '外部联系人',
  //   icon: externalIcon
  // }
];

const BaseContact: React.FunctionComponent = () => {
  const [selectGroup, setSelectGroup] = useState(CONTACT_TYPE.RECOMMEND);
  const [selectLabel, setSelectLabel] = useState<number>(0);
  const [showLabel, setShowLabel] = useState(false);
  const [showPopover, setShowPopover] = useState(true);
  // const [showLabelEditModal, setShowLabelEditModal] = useState(false);
  // const [labelPersonList, setLabelPersonList] = useState<Person[]>([]);
  // const [labelName, setLabelName] = useState<string>('');
  // const [isCreate, setIsCreate] = useState(true);

  const labelList: LabelList[] = useSelector((state: RootState) => state.contact.labelList);
  const orgContactList: any[] = useSelector((state: RootState) => state.contact.orgContactList);
  const contactList: Person[] = useSelector((state: RootState) => state.contact.contactList as any).map((c: any) => ({
    ...c,
    staffId: c.staffId || c.refId,
    company: c.orgName,
    department: c.department || c.orgName,
    commonCompany: c.commonCompany || c.orgName,
    avatar: c.avatar || c.cardPhoto
  }));
  const loading: boolean = useSelector((state: RootState) => state.contact.loading);

  const dispatch = useDispatch();

  useEffect(() => {
    if (cooperationSDK.isCoEnv && !getUserAuth()) return;
    dispatch(getContactList());
    dispatch(getOrgContactList());
  }, []);

  const groupCls = (isSelect: boolean) =>
    classnames(styles.group, {
      [styles.groupBorder]: isSelect
    });

  // const labelCls = (isSelect: boolean) =>
  //   classnames(styles.label, {
  //     [styles.labelBorder]: isSelect
  //   });

  const personListCls = () =>
    classnames(styles.personList, {
      [styles.coPersonList]: cooperationSDK.isCoEnv
    });

  const warpCls = classnames(styles.wrapper, {
    [styles.coWarpper]: cooperationSDK.isCoEnv
  });

  // 选择组
  const selectGroupClick = (key: string) => {
    if (key === CONTACT_TYPE.LABEL) {
      !selectLabel && !showLabel && dispatch(getLabels());
      setShowLabel(!showLabel);
    } else {
      setSelectGroup(key);
      key === CONTACT_TYPE.RECOMMEND ? dispatch(getContactList()) : dispatch(getExternalContactList());
      setSelectLabel(0);
    }
    const dt = groupData?.find((item: any) => item.key === key) || {};
    tracker?.reporteContactOperation('通讯录-' + dt?.text);
  };

  const getPersonCount = () => {
    switch (selectGroup) {
      case CONTACT_TYPE.RECOMMEND:
        return contactList.length;
      case CONTACT_TYPE.ORGANIZATION:
        return orgContactList[0]?.memberTotalCount ?? 0;
      default:
        return 0;
    }
  };

  // 选择标签
  // const selectLabelClick = (id: number) => {
  //   setSelectLabel(id);
  //   setSelectGroup(CONTACT_TYPE.LABEL);
  //   dispatch(getLabelList(id));
  // };

  // const getPersonList = () => {
  //   switch (selectGroup) {
  //     case CONTACT_TYPE.RECOMMEND:
  //       return contactList;
  //     case CONTACT_TYPE.ORGANIZATION:
  //       return orgContactList[0]?.memberDetailResponseList ?? [];
  //     default:
  //       return contactList;
  //   }

  // selectLabel
  //   ? (labelList.find((l) => l.id === selectLabel)?.contact || []).map((c) => ({
  //       ...c.person,
  //       remark: c.remark,
  //       relation: c.relation,
  //       commonCompany: c.commonCompany
  //     }))
  //   : selectGroup === CONTACT_TYPE.RECOMMEND
  //   ? contactList
  //   : externalContactList;
  // };

  const getHeader = () => (selectLabel ? labelList.find((l) => l.id === selectLabel)?.name : groupData.find((g) => g.key === selectGroup)?.text);

  const onClick = (e: React.MouseEvent<HTMLDivElement>) => {
    showPopover && setShowPopover(false);
    e.stopPropagation();
  };

  // const showLabelEdit = (isCreate: boolean) => {
  //   setShowLabelEditModal(true);
  //   setLabelPersonList(isCreate ? [] : getPersonList());
  //   setLabelName(isCreate ? '' : getHeader() || '');
  //   setIsCreate(isCreate);
  // };

  // const labelEditSubmit = (name: string, persons: Person[]) => {
  //   isCreate ? dispatch(createLabel({ persons, name })) : dispatch(updateLabelMember({ labelId: selectLabel, name, persons }));
  //   setShowLabelEditModal(false);
  // };

  // const deleteLabelClick = () => {
  //   ConfirmModal({
  //     title: '删除标签',
  //     content: '删除标签后无法恢复，确定要删除吗？',
  //     onOk: () => {
  //       dispatch(deleteLabel(selectLabel));
  //       const filterLabelList = labelList.filter((l) => l.id !== selectLabel);
  //       if (filterLabelList.length) {
  //         setSelectLabel(filterLabelList[0].id);
  //         dispatch(getLabelList(filterLabelList[0].id));
  //       } else {
  //         setSelectLabel(0);
  //         setSelectGroup(CONTACT_TYPE.RECOMMEND);
  //       }
  //     }
  //   });
  // };

  return (
    <>
      <div className={warpCls} onClick={onClick}>
        <div className={styles.type}>
          <SearchContact showPopover={showPopover} setShowPopover={(show: boolean) => setShowPopover(show)} />
          {/* 左侧导航栏 */}
          <div className={styles.groupList}>
            {groupData.map((group) => (
              <div key={group.key}>
                <div className={groupCls(group.key === selectGroup)} onClick={() => selectGroupClick(group.key)}>
                  <div>
                    <img src={group.icon} className={styles.icon} />
                    <span className={styles.text}>{group.text}</span>
                  </div>
                  <Icon
                    type={group.key === CONTACT_TYPE.LABEL && showLabel ? 'iconinput_arrow_down_ic1x' : 'iconlist_arrow_right_ic1x'}
                    size={18}
                    color="#000000"
                  />
                </div>
                {/* {group.key === CONTACT_TYPE.LABEL && showLabel && (
                  <>
                    <div className={styles.createLabel} onClick={() => showLabelEdit(true)}>
                      <Icon type="iconlabel_add_icon" color="#487ff8" size={24} />
                      <div className={styles.createLabelText}>新建标签</div>
                    </div>
                    {labelList.map((label) => (
                      <div key={label.id} className={labelCls(label.id === selectLabel)} onClick={() => selectLabelClick(label.id)}>
                        <span className={styles.name}>{label.name}</span>
                      </div>
                    ))}
                  </>
                )} */}
              </div>
            ))}
          </div>
        </div>

        <div className={styles.list}>
          <Spin spinning={loading}>
            <div className={styles.header}>
              <div className={styles.title}>
                <div className={styles.contactText}>{getHeader()}</div>
                <div className={styles.contactNumText}>{getHeader() ? '（共' + getPersonCount() + '人）' : ''}</div>
              </div>
              {/* {!!selectLabel && (
                <div className={styles.labelEdit}>
                  <div className={styles.labelEditIcon}>
                    <Icon type="iconlabel_edit_icon" size={24} color="rgba(0, 0, 0, .64)" onClick={() => showLabelEdit(false)} />
                  </div>
                  <Icon type="iconlabel_delete_icon" size={24} color="rgba(0, 0, 0, .64)" onClick={deleteLabelClick} />
                </div>
              )} */}
            </div>

            {selectGroup === CONTACT_TYPE.ORGANIZATION ? (
              <OrganizationList
                className={personListCls()}
                personList={orgContactList}
                type={selectGroup}
                labelId={selectLabel}
                contactCard
                setShowPopover={(show: boolean) => setShowPopover(show)}
                showLetter={!selectLabel}
                noPersonText="暂无联系人"
              />
            ) : (
              <PersonList
                className={personListCls()}
                personList={contactList}
                type={selectGroup}
                labelId={selectLabel}
                contactCard
                setShowPopover={(show: boolean) => setShowPopover(show)}
                showLetter={!selectLabel}
                noPersonIcon={noContactImg}
                noPersonText="暂无联系人"
              />
            )}
          </Spin>
        </div>
      </div>

      {/* <ContactEditModal
        labelName={labelName}
        isCreate={isCreate}
        show={showLabelEditModal}
        close={() => setShowLabelEditModal(false)}
        onSumit={labelEditSubmit}
        personList={labelPersonList}
      /> */}
    </>
  );
};

export default BaseContact;
